/* eslint-disable import/no-default-export */
import { SET_GENERATION_ID_SELECTED } from '../../actionTypes'

const initialState = {
    generationIdSelected: 0
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_GENERATION_ID_SELECTED: {
            const { content } = action.payload
            return {
                ...state,
                generationIdSelected: content
            }
        }
        default:
            return state
    }
}
